import styled from "styled-components";

interface IContainer {
  haveBalance?: any;
}
export const Container = styled.div<IContainer>`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  height: ${(props) => (props.haveBalance ? "61.2rem" : "51.1rem")};
  padding: 4rem 2.5rem;
  width: 42.4rem;

  h1 {
    color: #2e353d;
    font-family: "Montserrat";
    font-size: 2rem;
    font-style: normal;
    font-weight: 800;
    line-height: 2.4rem;
  }

  h2 {
    color: ${(props) => (props.haveBalance ? "#88b13b" : "#FF6F61")};
    font-family: "Montserrat";
    font-size: 1.8rem;
    font-style: normal;
    font-weight: 600;
    line-height: 2.4rem;
    text-align: center;
  }

  label {
    color: rgba(8, 8, 43, 0.55);
    font-family: "Montserrat";
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 500;
    line-height: 2.4rem;
    margin-bottom: 1.9rem;
    text-align: center;
  }
`;
